// ============================================================
// MANIC MEETER — English content: the colleague without English
// ============================================================
// Mirror of ../de/foreign.ts. In German the outsider is Dave from London; in
// English it is Hans-Peter, who was here long before somebody declared English
// the company language and has been nodding through it ever since. Whoever is
// the foreigner speaks the language the player did *not* choose.

import type { ForeignColleagueContent } from "../contract";

export const FOREIGN_COLLEAGUE: ForeignColleagueContent = {
  name: "Hans-Peter",
  roleLabel: "Colleague from before the English mandate",
  tenure: "23 years in this building",
  subtitle: "[no translation available]",
  tooltip:
    "In 2019 MegaCorp™ made English the official company language. Hans-Peter had already been "
    + "here fourteen years. He was not consulted. He has attended every meeting since and has never "
    + "once asked what was decided.",
  introduction:
    "🌍 <strong>Hans-Peter</strong> is here too. He has worked here for 23 years and speaks no English. "
    + "The company switched languages around him. He simply kept talking.",
  phrases: [
    "Also, ich sag mal so: das haben wir 2011 schon probiert.",
    "Ich versteh das jetzt nicht ganz, aber ich bin dagegen.",
    "Bevor hier alle Englisch geredet haben, ging das schneller.",
    "Genau. Genau genau. Genau.",
    "Ich hab das mal an die Kollegen weitergeleitet. An welche, weiß ich nicht mehr.",
    "Kann mir nochmal jemand sagen, was ein 'stakeholder' ist? Auf Deutsch.",
    "Ich hab damals das ganze System aufgesetzt. Es läuft heute noch. Fragt mich keiner.",
    "Das steht so im Protokoll. Ich hab's nicht gelesen, aber es steht da.",
    "Wir hatten früher einen Betriebsrat, der sowas verhindert hätte.",
    "Ich mach das seit 23 Jahren. Ich mach das auch weiterhin so.",
    "'Alignment'? Wir haben früher einfach kurz telefoniert.",
    "Der Praktikant hat mir das erklärt. Ich hab genickt. Es war sehr überzeugend.",
    "Ich hab dazu eine Excel. Die ist von 2014. Sie funktioniert immer noch.",
    "Also ich sag ja nichts, aber ich sag's trotzdem.",
    "Meine Tochter hat Englisch studiert. Die versteht das alles.",
    "Wenn ihr fertig seid, sagt kurz Bescheid, dann sag ich meine Meinung.",
    "Das Wichtigste ist doch, dass der Kunde zufrieden ist. Oder nicht? Ist er?",
    "Diese KI da — schreibt die auch Deutsch? Nein? Na also.",
    "Ich geh dann mal in die Kantine. Da spricht wenigstens noch jemand normal.",
    "Noch 18 Monate. Dann sollen sie reden, wie sie wollen.",
  ],
  addressPhrases: [
    "Du verstehst mich doch, oder? Sag denen mal, was ich meine.",
    "Was hat der jetzt gesagt? Das war doch gegen mich.",
    "Du bist doch auch von hier. Erklär du das mal.",
    "Sag mal ehrlich: geht das nur mir so?",
    "Kannst du das kurz übersetzen? Nicht für mich. Für die.",
  ],
};
